import React from "react";
import {useTranslation} from "react-i18next";
import '../../i18n/config';

export const Footer = () => {
    const {t} = useTranslation();

    return (
        <div className="footer">
            <ul>
                <li><a href={process.env.PUBLIC_URL}>{t("トップ")}</a></li>
                <li><a href="https://jourcy.com/about.html">{t("運営")}</a></li>
                <li><a href="https://jourcy.com/terms.html">{t("利用規約")}</a></li>
                <li><a href="https://jourcy.com/privacy-policy.html">{t("プライバシーポリシー")}</a></li>
                <li><a href="https://forms.gle/sKUwQUCQY668s6aA6">{t("お問い合わせ")}</a></li>
            </ul>
            <span className="copy-right">Copyright&copy; JourneyCycle All Right Reserved.</span>
        </div>
    );
}
